<template>
  <section v-if="page.banners && page.banners.length">
    <div class="slideshow">
      <slide-show ref="slideshow" @slide-change="imagenumber = $event">
        <div class="slide" v-for="image in page.banners" :key="image._key">
          <div class="container">
            <img :src="image.image" :alt="image.caption_1 || image.caption_2" />
            <div class="caption" v-if="isHomePage">
              <h3 v-if="image.caption_1">
                <span>{{ image.caption_1 }}</span>
              </h3>
              <h4 v-if="image.caption_2">
                <span>{{ image.caption_2 }}</span>
              </h4>
            </div>
          </div>
        </div>
      </slide-show>
      <div class="controls" v-if="isHomePage">
        <a class="prev" @click.prevent="showPrev" href aria-label="Previous">
          <font-awesome-icon icon="chevron-left" />
        </a>
        <a class="next" @click.prevent="showNext" href aria-label="Next">
          <font-awesome-icon icon="chevron-right" />
        </a>
      </div>
      <div class="links" v-if="isHomePage">
        <router-link to="/our-developments">Our developments</router-link>
        <page-link v-if="mortgagesPage" :to="mortgagesPage.url">Buying with us</page-link>
        <page-link v-if="contactPage" :to="contactPage.url">Get in touch</page-link>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex"

export default {
  data: function() {
    return { imagenumber: 1 }
  },
  computed: {
    ...mapState(["page", "mortgagesPage", "contactPage"]),
    ...mapGetters(["isHomePage"])
  },
  methods: {
    showNext() {
      if (this.imagenumber == this.page.banners.length) this.$refs.slideshow.show(1)
      else this.$refs.slideshow.show(this.imagenumber + 1)
    },
    showPrev() {
      if (this.imagenumber == 1) this.$refs.slideshow.show(this.page.banners.length)
      else this.$refs.slideshow.show(this.imagenumber - 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slideshow {
  position: relative;
  line-height: 0;
}

.mask {
  position: absolute;
  bottom: 0;
  z-index: 10;
  width: 100%;
  display: none;
}

.slide {
  width: 100%;
  overflow: hidden;
}

.slide img {
  width: 100%;
  position: relative;
  z-index: 1;
}

.caption {
  line-height: 1.2;
  position: absolute;
  z-index: 2;
  left: 20%;
  width: 60%;
  top: 22%;
  text-align: center;
  transform: translateY(-50%);
  font-size: 5rem;
  color: #fff;
  padding: 1rem 0;
}

.links {
  color: White;
  width: 100%;
  text-align: center;
  position: absolute;
  z-index: 20;
  bottom: 15%;
}

.links a {
  width: 15%;
  display: inline-block;
  background: rgba(255, 255, 255, 0.9);
  line-height: 1.3;
  padding: 1rem;
  margin: 2rem;
  font-size: 2rem;
  transition: all 0.2s;
  color: #455c6e;
}

.links a:hover {
  background: #d1ae54;
  transform: scale(1.1);
}

.caption h3,
.caption h4 {
  font-weight: 400;
  clear: both;
  display: block;
  margin: 0;
  line-height: 1.5;
}

.caption h3 span {
  color: white;
  text-shadow: 1px 1px 15px rgb(0 0 0 / 85%);
}

.caption h4 {
  font-size: 4rem;
}

.caption h4 span {
  color: white;
  text-shadow: 1px 1px 15px rgb(0 0 0 / 85%);
}

.controls {
  position: absolute;
  top: 50%;
  left: 5%;
  width: 90%;
  transform: translateY(-50%);
  z-index: 3;
  color: #fff;
  font-size: 5rem;
}

.next {
  float: right;
}

.controls a {
  transition: all 0.2s;
  display: inline-block;
}

.controls a:hover {
  transform: scale(1.2);
  color: #a39064;
}

@media screen and (max-width: 1300px) {
  .caption {
    font-size: 4rem;
  }
  .caption h4 {
    font-size: 3rem;
  }
}

@media screen and (max-width: 980px) {
  .slide img {
    width: 150%;
    max-width: 150%;
    left: -25%;
  }
  .controls {
    display: none;
  }
  .caption {
    width: 80%;
    left: 10%;
  }
  .links a {
    width: 25%;
    font-size: 1.6rem;
  }
}

@media screen and (max-width: 700px) {
  .caption {
    font-size: 2.5rem;
  }
  .caption h4 {
    font-size: 2.2rem;
    margin-top: 0.5rem;
  }
}

@media screen and (max-width: 500px) {
  .slide img {
    width: 200%;
    max-width: 200%;
    left: -50%;
  }
  .links a {
    margin: 0 1rem;
  }
}
</style>
